<template>
    <div class="box-modal fade" :id="id" tabindex="-1" role="dialog" aria-hidden="true">
        <div class="modal-content">
            <div class="modal-header">
                <button data-element="close_cart_modal_confirm" type="button" class="close ui ui-cross" @click="cancel()"></button>
            </div>
            <div class="modal-body" v-html="body"></div>
            <div class="modal-footer">
                <button data-element="ok_cart_modal_confirm" class="btn md" @click="confirm()">{{ okTitle }}</button>
                <button data-element="cancel_cart_modal_confirm" class="btn md link" @click="cancel()">{{ cancelTitle }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ModalConfirm',
    props: {
        id: {
            type: String,
            require: true,
        },
        body: {
            type: String,
        },
        okTitle: {
            type: String,
        },
        cancelTitle: {
            type: String,
        },
        confirmFunction: {
            type: Function,
        },
        cancelFunction: {
            type: Function,
        },
    },
    methods: {
        close () {
            this.$emit('close');
        },
        confirm() {
            const t = this;
            var resConfirmFunction;
            if (typeof t.confirmFunction === 'function') {
                resConfirmFunction = t.confirmFunction();
            }
            if (resConfirmFunction !== false) {
                t.close();
            }
        },
        cancel() {
            const t = this;
            var resCancelFunction;
            if (typeof t.cancelFunction === 'function') {
                resCancelFunction = t.cancelFunction();
            }
            if (resCancelFunction !== false) {
                t.close();
            }
        }
    }
}
</script>